import {LitElement, html} from 'lit';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';

/* global customElements */
class ApplicationModuleGrid extends BaseComponent {

	static get properties() {
		return {};
	}

	constructor() {
		super();
		var applicationModuleGrid = this;
		setTimeout(function() {
			applicationModuleGrid.init();
		});
	}

	render() {
		return html`<slot></slot>`;
	}

	init() {
		var applicationModuleGrid = this;

		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children: [ElementUtil.makeIcon('vaadin:refresh', ' Refresh')],
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'status',
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'description',
					label: 'Status',
					value: 'A',
					style: 'width: 160px;',
					postinit: function(combo) {
						combo.items = [
							{code: 'A', description: 'Active'},
							{code: 'I', description: 'Inactive'}
						];
					},
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					children: [ElementUtil.makeIcon('vaadin:plus', ' Add')],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'edit',
					disabled: true,
					'class': 'spacer-toolbar-item',
					children: [ElementUtil.makeIcon('vaadin:edit', ' Edit')],
					listeners: {
						click: function() {
							var selected = ElementUtil.query(applicationModuleGrid, 'grid').selectedItems;
							if (selected && selected.length === 1) {
								actionAddEdit(selected[0]);
							} else {
								DL.MessageUtil.warningMessage('Select one Application Module to edit');
							}
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'toggle',
					disabled: true,
					'class': 'spacer-toolbar-item',
					children: [ElementUtil.makeIcon('vaadin:exchange', ' Toggle Status')],
					listeners: {
						click: function() {
							var selected = ElementUtil.query(applicationModuleGrid, 'grid').selectedItems;
							if (selected && selected.length === 1) {
								actionToggleStatus(selected[0]);
							} else {
								DL.MessageUtil.warningMessage('Select one Application Module');
							}
						}
					}
				}
			]
		});

		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			itemid: 'grid',
			theme: 'row-stripes column-borders',
			slot: 'primary',
			style: 'height: 100%;',
			'column-reordering-allowed': '',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
						}
					}
				}
			},
			children: [
				{path: 'code', header: 'Code', width: '10em'},
				{path: 'description', header: 'Description', 'flex-grow': '1'},
				{
					path: 'dataFeed',
					header: 'Data Feed',
					width: '8em',
					renderer: function(root, column, rowData) {
						root.textContent = rowData.item.dataFeed ? 'Yes' : 'No';
					}
				},
				{
					path: 'restricted',
					header: 'Restricted',
					width: '8em',
					renderer: function(root, column, rowData) {
						root.textContent = rowData.item.restricted ? 'Yes' : 'No';
					}
				},
				{path: 'activeStatus', header: 'Status', width: '6em'}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0 && !grid.selectedItems[0].coreModule) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'toggle').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'toggle').disabled = true;
					}
				}
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});
		applicationModuleGrid.append(flexLayout);

		var actionRefresh = function() {
			var loadMask = DL.MessageUtil.fullPageLoadMask();
			Service.getApplicationModuleService().getModules({
				status: ElementUtil.query(toolbar, 'status').value
			}).then(function(modules) {
				loadMask.opened = false;
				grid.items = modules;
			}).catch(function(error) {
				loadMask.opened = false;
				DL.MessageUtil.errorMessage(error);
			});
		};

		var actionToggleStatus = function(record) {
			var promise;
			if (record.activeStatus === 'A') {
				promise = Service.getApplicationModuleService().inactivateModule(record.code);
			} else {
				promise = Service.getApplicationModuleService().activateModule(record.code);
			}
			var loadMask = DL.MessageUtil.fullPageLoadMask();
			promise.then(function() {
				loadMask.opened = false;
				actionRefresh();
			}).catch(function(error) {
				loadMask.opened = false;
				DL.MessageUtil.errorMessage(error);
			});
		};

		var actionAddEdit = function(record) {
			var edit = !!record;
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: (edit ? 'Edit' : 'Add') + ' Application Module',
				icon: 'vaadin:cogs',
				width: .8,
				height: .9,
				listeners: {
					ready: function() {
						addEditWin.show();

						var detail = {
							module: {
								code: '',
								description: '',
								dataFeed: false,
								restricted: false,
								activeStatus: 'A'
							},
							dataHandlers: [],
							integrationConfig: null
						};
						var handlerRows = [];

						var handlerToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									children: [ElementUtil.makeIcon('vaadin:plus', ' Add')],
									listeners: {
										click: function() {
											actionAddEditHandler();
										}
									}
								},
								{
									tag: 'vaadin-button',
									itemid: 'edit',
									'class': 'spacer-toolbar-item',
									disabled: true,
									children: [ElementUtil.makeIcon('vaadin:edit', ' Edit')],
									listeners: {
										click: function() {
											actionAddEditHandler(handlerGrid.selectedItems[0]);
										}
									}
								},
								{
									tag: 'div',
									style: 'float: right;',
									children: [
										{
											tag: 'vaadin-button',
											itemid: 'delete',
											disabled: true,
											theme: 'error primary',
											'class': 'spacer-toolbar-item',
											children: [ElementUtil.makeIcon('vaadin:trash', ' Remove')],
											listeners: {
												click: function() {
													actionDeleteHandler(handlerGrid.selectedItems[0]);
												}
											}
										}
									]
								}
							]
						});

						var handlerGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'wrap-cell-content row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									path: 'dataTypeDescription',
									header: 'Data Type',
									width: '12em',
									renderer: function(root, column, rowData) {
										root.textContent = rowData.item.dataTypeDescription || rowData.item.dataType || '';
									}
								},
								{
									path: 'defaultDataHandlerDescription',
									header: 'Default Data Handler',
									'flex-grow': '1',
									renderer: function(root, column, rowData) {
										root.textContent = rowData.item.defaultDataHandlerDescription
											|| rowData.item.defaultDataHandler || '';
									}
								}
							],
							listeners: {
								'active-item-changed': function(event) {
									const item = event.detail.value;
									handlerGrid.selectedItems = item ? [item] : [];
									var hasSelection = handlerGrid.selectedItems.length > 0;
									ElementUtil.query(handlerToolbar, 'edit').disabled = !hasSelection;
									ElementUtil.query(handlerToolbar, 'delete').disabled = !hasSelection;
								}
							}
						});

						var codeField = {
							tag: 'vaadin-text-field',
							label: 'Code',
							name: 'code',
							required: true,
							maxlength: 80
						};
						// ElementUtil.setAttribute treats disabled:false as present, which still disables the field
						if (edit) {
							codeField.disabled = true;
						}

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										codeField,
										{
											tag: 'vaadin-text-field',
											label: 'Description',
											name: 'description',
											required: true,
											maxlength: 255
										},
										{
											tag: 'vaadin-checkbox',
											name: 'dataFeed',
											label: 'Data Feed'
										},
										{
											tag: 'vaadin-checkbox',
											name: 'restricted',
											label: 'Restricted',
											'helper-text': 'Restricts visibility of this module to specific company types.'
										},
										{
											tag: 'dl-section-title',
											title: 'Default Data Handlers',
											colspan: 2,
											style: 'margin-top: 20px;'
										},
										{
											tag: 'div',
											itemid: 'handlerSection',
											style: 'height: 250px;',
											colspan: 2,
											children: [
												{
													tag: 'dl-flex-layout',
													children: [
														handlerToolbar,
														handlerGrid
													]
												}
											]
										},
										{
											tag: 'dl-section-title',
											title: 'Integration Runtime Config (optional)',
											colspan: 2,
											style: 'margin-top: 20px;'
										},
										{
											tag: 'vaadin-integer-field',
											label: 'Max Back-Pull Minutes',
											name: 'maxBackPullMinutes'
										},
										{
											tag: 'vaadin-integer-field',
											label: 'Max Runtime Before Override',
											name: 'maxRunTimeBeforeOverride'
										},
										{
											tag: 'vaadin-integer-field',
											label: 'Max Work Pool Size',
											name: 'maxWorkPoolSize'
										},
										{
											tag: 'vaadin-checkbox',
											name: 'bufferOnCheckFailure',
											label: 'Buffer On Check Failure'
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'availabilityCheckCode',
											label: 'Availability Check',
											name: 'availabilityCheckCode',
											'item-value-path': 'code',
											'item-label-path': 'description',
											clearButtonVisible: true,
											placeHolder: 'Select',
											postinit: function(combo) {
												Service.getApplicationModuleService().getAvailabilityChecks().then(function(checks) {
													combo.items = checks || [];
												});
											}
										}
									]
								},
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [ElementUtil.makeIcon('vaadin:database', ' Save')],
													listeners: {
														click: function() {
															formPanel.submitForm({
																preSubmit: function(data) {
																	var module = {
																		code: data.code,
																		description: data.description,
																		dataFeed: !!data.dataFeed,
																		restricted: !!data.restricted,
																		activeStatus: detail.module.activeStatus || 'A'
																	};
																	var config = null;
																	if (data.maxBackPullMinutes || data.maxRunTimeBeforeOverride || data.maxWorkPoolSize
																			|| data.availabilityCheckCode || data.bufferOnCheckFailure !== undefined) {
																		config = {
																			applicationModule: module.code,
																			maxBackPullMinutes: data.maxBackPullMinutes ? parseInt(data.maxBackPullMinutes, 10) : null,
																			maxRunTimeBeforeOverride: data.maxRunTimeBeforeOverride ? parseInt(data.maxRunTimeBeforeOverride, 10) : null,
																			maxWorkPoolSize: data.maxWorkPoolSize ? parseInt(data.maxWorkPoolSize, 10) : null,
																			bufferOnCheckFailure: !!data.bufferOnCheckFailure,
																			availabilityCheckCode: data.availabilityCheckCode || null
																		};
																	}
																	var dataHandlers = handlerRows.map(function(row) {
																		return {
																			dataType: row.dataType,
																			defaultDataHandler: row.defaultDataHandler
																		};
																	});
																	return {
																		module: module,
																		dataHandlers: dataHandlers,
																		integrationConfig: config
																	};
																},
																actualCall: function(saveModel) {
																	return Service.getApplicationModuleService().saveModule(saveModel, edit);
																},
																success: function() {
																	window.DL.MessageUtil.showToast('Success', 'Saved Application Module', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						addEditWin.addToContentElement(formPanel);

						var actionRefreshHandlers = function() {
							handlerGrid.activeItem = null;
							handlerGrid.items = handlerRows.slice();
						};

						var resolveHandlerDisplay = function(rows) {
							return Promise.all([
								DataManagementService.getDataHandlerService().getDataHandlers(),
								Service.getLookupService().getLookupValues('DataType')
							]).then(function(results) {
								var handlers = results[0] || [];
								var dataTypes = results[1] || [];
								var handlerMap = {};
								handlers.forEach(function(handler) {
									handlerMap[handler.handlerId] = handler.description;
								});
								var dataTypeMap = {};
								dataTypes.forEach(function(dataType) {
									dataTypeMap[dataType.code] = dataType.description;
								});
								rows.forEach(function(row) {
									row.dataTypeDescription = dataTypeMap[row.dataType] || row.dataType;
									row.defaultDataHandlerDescription = handlerMap[row.defaultDataHandler] || row.defaultDataHandler;
								});
								return rows;
							});
						};

						var actionAddEditHandler = function(handler) {
							var addEditHandlerWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: handler ? 'Edit Handler' : 'Add Handler',
								icon: 'vaadin:edit',
								width: 500,
								height: 280,
								listeners: {
									ready: function() {
										addEditHandlerWin.show();

										var loadHandlersForDataType = function(dataType) {
											var handlerCombo = ElementUtil.query(handlerFormPanel, 'defaultDataHandler');
											if (!dataType) {
												handlerCombo.items = [];
												return Promise.resolve([]);
											}
											return DataManagementService.getIntegrationService().getDataHandlers(null, dataType).then(function(handlers) {
												handlerCombo.items = handlers || [];
												return handlers || [];
											});
										};

										var handlerFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-combo-box',
															itemid: 'dataType',
															name: 'dataType',
															label: 'Data Type',
															'item-value-path': 'code',
															'item-label-path': 'description',
															required: true,
															placeHolder: 'Select',
															postinit: function(combo) {
																Service.getLookupService().getLookupValues('DataType').then(function(data) {
																	combo.items = data;
																	if (handler) {
																		loadHandlersForDataType(handler.dataType).then(function() {
																			handlerFormPanel.load(handler);
																		});
																	}
																});
															},
															listeners: {
																change: function(event) {
																	var selectedDataType = event.target.value;
																	loadHandlersForDataType(selectedDataType);
																	if (!handler || selectedDataType !== handler.dataType) {
																		ElementUtil.query(handlerFormPanel, 'defaultDataHandler').value = '';
																	}
																}
															}
														},
														{
															tag: 'vaadin-combo-box',
															itemid: 'defaultDataHandler',
															name: 'defaultDataHandler',
															label: 'Default Data Handler',
															'item-value-path': 'handlerId',
															'item-label-path': 'description',
															required: true,
															placeHolder: 'Select'
														}
													]
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [ElementUtil.makeIcon('vaadin:database', ' Save')],
																	listeners: {
																		click: function() {
																			if (!handlerFormPanel.isValid()) {
																				return;
																			}
																			var data = handlerFormPanel.getData();
																			var dataTypeCombo = ElementUtil.query(handlerFormPanel, 'dataType');
																			var handlerCombo = ElementUtil.query(handlerFormPanel, 'defaultDataHandler');
																			var row = {
																				dataType: data.dataType,
																				dataTypeDescription: dataTypeCombo.selectedItem
																					? dataTypeCombo.selectedItem.description : data.dataType,
																				defaultDataHandler: data.defaultDataHandler,
																				defaultDataHandlerDescription: handlerCombo.selectedItem
																					? handlerCombo.selectedItem.description : data.defaultDataHandler
																			};
																			if (handler) {
																				handler.dataType = row.dataType;
																				handler.dataTypeDescription = row.dataTypeDescription;
																				handler.defaultDataHandler = row.defaultDataHandler;
																				handler.defaultDataHandlerDescription = row.defaultDataHandlerDescription;
																			} else {
																				handlerRows.push(row);
																			}
																			actionRefreshHandlers();
																			addEditHandlerWin.close();
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function() {
																			addEditHandlerWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										addEditHandlerWin.addToContentElement(handlerFormPanel);
									}
								}
							});
						};

						var actionDeleteHandler = function(handler) {
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: 'Are you sure you want to remove the selected data handler?',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											handlerRows = handlerRows.filter(function(row) {
												return !(row.dataType === handler.dataType
													&& row.defaultDataHandler === handler.defaultDataHandler);
											});
											actionRefreshHandlers();
										}
									},
									{
										text: 'No'
									}
								]
							});
						};

						var loadMask = formPanel.showLoading('Loading...');
						Promise.resolve(edit ? Service.getApplicationModuleService().getModuleDetail(record.code) : null)
							.then(function(moduleDetail) {
								if (moduleDetail) {
									detail = moduleDetail;
								}
								handlerRows = (detail.dataHandlers || []).slice();
								return resolveHandlerDisplay(handlerRows);
							}).then(function() {
								loadMask.remove();
								var integrationConfig = detail.integrationConfig || {
									maxBackPullMinutes: null,
									maxRunTimeBeforeOverride: null,
									maxWorkPoolSize: null,
									bufferOnCheckFailure: true,
									availabilityCheckCode: ''
								};
								formPanel.load({
									code: detail.module.code,
									description: detail.module.description,
									dataFeed: !!detail.module.dataFeed,
									restricted: !!detail.module.restricted,
									maxBackPullMinutes: integrationConfig.maxBackPullMinutes || '',
									maxRunTimeBeforeOverride: integrationConfig.maxRunTimeBeforeOverride || '',
									maxWorkPoolSize: integrationConfig.maxWorkPoolSize || '',
									bufferOnCheckFailure: integrationConfig.bufferOnCheckFailure !== false,
									availabilityCheckCode: integrationConfig.availabilityCheckCode || ''
								}, {
									refreshComponents: true
								});
								actionRefreshHandlers();
							}).catch(function(error) {
								loadMask.remove();
								DL.MessageUtil.errorMessage(error);
							});
					}
				}
			});
		};

		actionRefresh();
	}
}

customElements.define('dl-application-module-grid', ApplicationModuleGrid);
